import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { $document } from '../document';
import { Event } from '../Event';
import { getCanvas } from '../register';

var TouchEvent = function (_Event) {
  _inherits(TouchEvent, _Event);

  var _super = _createSuper(TouchEvent);

  function TouchEvent(type) {
    var _this;

    _classCallCheck(this, TouchEvent);

    _this = _super.call(this, type);

    _defineProperty(_assertThisInitialized(_this), "touches", void 0);

    _defineProperty(_assertThisInitialized(_this), "targetTouches", void 0);

    _defineProperty(_assertThisInitialized(_this), "changedTouches", void 0);

    _this.touches = [];
    _this.targetTouches = [];
    _this.changedTouches = [];
    _this.target = getCanvas();
    _this.currentTarget = getCanvas();
    return _this;
  }

  return TouchEvent;
}(Event);

function mapEvent(event) {
  var _ref = event || {},
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y,
      _ref$clientX = _ref.clientX,
      clientX = _ref$clientX === void 0 ? 0 : _ref$clientX,
      _ref$clientY = _ref.clientY,
      clientY = _ref$clientY === void 0 ? 0 : _ref$clientY;

  if (Object.keys(event).indexOf('x') !== -1) {
    event.pageX = event.clientX = x;
    event.pageY = event.clientY = y;
  } else {
    event.x = clientX;
    event.y = clientY;
  }
}

function eventHandlerFactory(type) {
  return function (rawEvent) {
    var event = new TouchEvent(type);
    event.changedTouches = rawEvent.changedTouches;
    event.touches = rawEvent.touches;
    event.targetTouches = Array.prototype.slice.call(rawEvent.touches);
    event.timeStamp = rawEvent.timeStamp;
    event.changedTouches.forEach(function (e) {
      return mapEvent(e);
    });
    event.touches.forEach(function (e) {
      return mapEvent(e);
    });
    event.targetTouches.forEach(function (e) {
      return mapEvent(e);
    });
    $document.dispatchEvent(event);
  };
}

function eventMapHandlerFactory(type) {
  return function (rawEvent) {
    rawEvent.type = type;
    $document.dispatchEvent(rawEvent);
  };
}

var dispatchTouchStart = eventHandlerFactory('touchstart');
var dispatchTouchMove = eventHandlerFactory('touchmove');
var dispatchTouchEnd = eventHandlerFactory('touchend');
var dispatchMapCameraParams = eventMapHandlerFactory('mapCameaParams');
export { dispatchTouchStart, dispatchTouchMove, dispatchTouchEnd, dispatchMapCameraParams };
//# sourceMappingURL=TouchEvent.js.map